/**
 * Records Management — Wave 6.3 SuperAdmin module entry.
 *
 * Top-level tabs (per Wave 6.3 brief §D):
 *   1. Records browser           — filterable across record types
 *   2. Hard-delete dialog        — surfaced inside Browser kebab
 *   3. Bulk corrections dialog   — surfaced inside Browser bulk-select
 *   4. Test Mode wipe            — confirm-typed phrase, no SQL audit history
 *   5. Purge History viewer      — searchable audit
 *   6. Recovery wizard           — restore from SP snapshot
 *   7. Retention Hold subtab     — list + add/remove holds
 *
 * Mounted at `/super-admin/records/*`. SuperAdmin role-gated.
 */

import { Routes, Route, Navigate } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import { RecordsManagementShell } from './RecordsManagementShell';
import { RecordsBrowserTab } from './tabs/RecordsBrowserTab';
import { TestModeWipeTab } from './tabs/TestModeWipeTab';
import { PurgeHistoryTab } from './tabs/PurgeHistoryTab';
import { RecoveryWizardTab } from './tabs/RecoveryWizardTab';
import { RetentionHoldsTab } from './tabs/RetentionHoldsTab';

export default function RecordsManagementModule(): JSX.Element {
  return (
    <Routes>
      <Route element={<RecordsManagementShell />}>
        <Route index element={<Navigate to="browser" replace />} />
        <Route path="browser" element={<RecordsBrowserTab />} />
        <Route path="test-mode-wipe" element={<TestModeWipeTab />} />
        <Route path="purge-history" element={<PurgeHistoryTab />} />
        <Route path="recovery" element={<RecoveryWizardTab />} />
        <Route path="retention-holds" element={<RetentionHoldsTab />} />
        <Route path="*" element={<SplatRedirect to="browser" />} />
      </Route>
    </Routes>
  );
}
